import React, { useEffect, useState } from 'react';

function FloatingBubbles() {
  const [bubbles, setBubbles] = useState([]);

  useEffect(() => {
    const numBubbles = 75; 

    const newBubbles = Array.from({ length: numBubbles }, (_, index) => ({
      id: index,
      x: Math.random() * window.innerWidth,
      // y: window.innerHeight + Math.random() * 100, 
      y: window.innerHeight,
      size: Math.random() * 30 + 15, 
      speed: Math.random() * 2 + 2, 
      color: getRandomColor(), 
    }));

    setBubbles(newBubbles);
    const timeout = setTimeout(() => {
      setBubbles([]);
    }, 8000 *2); 

    return () => clearTimeout(timeout);
  }, []);

  const getRandomColor = () => {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  return (
    <div className="bubbles-container">
      {bubbles.map((bubble) => (
        <div
          key={bubble.id}
          className="bubble"
          style={{
            top: bubble.y,
            left: bubble.x,
            width: bubble.size,
            height: bubble.size,
            backgroundColor: bubble.color,
            animation: `float ${bubble.speed}s ease-in-out forwards`,
          }}
        />
      ))}
    </div>
  );
}

export default FloatingBubbles;
